import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmCustomQueueRoute: InvariantJiraRoute = {
	name: 'csm-queues-custom-view',
	path: '/jira/customer-service-management/projects/:projectKey/queues/custom/:queueId',
	exact: true,
};
